import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import NumberFormat from "react-number-format";
import SimpleContext from "../context/SimpleContext";

const BasketInfo = ({
  finalPrice,
  length,
  finalCustomerPrice,
  finalDiscount,
}) => {
  const stylee = {
    display: "flex",
    fontWeight: "bold",
    color: "#4c4b4b",
  };
  const stylee2 = {
    fontWeight: "bold",
    color: "#4c4b4b",
  };
  const context = useContext(SimpleContext);
  return (
    <>
      <div className="basketInfo">
        <h1 style={{ fontSize: "15px", fontWeight: "bold" }}>
          اطلاعات سبد خرید
        </h1>
        <br />
        <Row className="basketInfoTable">
          <Col>
            <p style={stylee}>تعداد اقلام</p>
          </Col>
          <Col style={{ textAlign: "left" }}>
            <p style={stylee2}>{length} کالا</p>
          </Col>
        </Row>
        <Row className="basketInfoTable">
          <Col>
            <p style={stylee}>جمع مبلغ کالاها</p>
          </Col>
          <Col style={{ textAlign: "left" }}>
            {context.RialOrToman === true ? (
              <p style={stylee2}>
                <NumberFormat
                  value={parseInt(finalPrice / 10)}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                تومان
              </p>
            ) : (
              <p style={stylee2}>
                <NumberFormat
                  value={parseInt(finalPrice)}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                ریال
              </p>
            )}
          </Col>
        </Row>
        <Row className="basketInfoTable">
          <Col>
            <p style={stylee}>جمع تخفیف</p>
          </Col>
          <Col style={{ textAlign: "left" }}>
            {context.RialOrToman === true ? (
              <p style={stylee2}>
                <NumberFormat
                  value={parseInt(finalDiscount / 10)}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                تومان
              </p>
            ) : (
              <p style={stylee2}>
                <NumberFormat
                  value={parseInt(finalDiscount)}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                ریال
              </p>
            )}
          </Col>
        </Row>
        <hr style={{ width: "100%", color: "gray" }} />
        <div
          style={{
            width: "100%",
            color: "#4c4b4b",
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          <p>
            کالاهای موجود در سبد خرید شما ثبت و رزرو نشده اند. برای ثبت سفارش
            مراحل بعدی را تکمیل کنید.
          </p>
        </div>
      </div>
    </>
  );
};

export default BasketInfo;
